import { MedicalPaOrder } from "../../../../data-model/medicalPaOrdersModel";
import { InfoIcon } from "../../../../svg/info-icon";
import { getRpaStatusBanner } from "../../utils/bannerConfig";

interface RpaStatusBannerProps {
  orderData: MedicalPaOrder;
}

export const RpaStatusBanner: React.FC<RpaStatusBannerProps> = ({
  orderData,
}) => {
  const bannerConfig = getRpaStatusBanner(orderData);

  if (!bannerConfig.show) {
    return null;
  }

  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-4">
      <div className="flex flex-col items-center justify-center gap-2">
        <InfoIcon height="36" width="36" stroke="#0056d6" strokeWidth="1.4" />
        <div className="text-center">
          Please wait while we retrive the Auth on file run status.
          <br />
          You may revisit this page after a few minutes for the updated status.
        </div>
      </div>
    </div>
  );
};
